export const LEDGER_CLIENT_VERSION_HEADER = "X-Ledger-Client-Version";
export const LEDGER_ORIGIN_TOKEN_HEADER = "X-Ledger-Client-Origin";
